import { html as v, svg as h } from "./index-BqflxSah.js";
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const u = Symbol.for(""), d = (t) => {
  if ((t == null ? void 0 : t.r) === u)
    return t == null ? void 0 : t._$litStatic$;
}, m = (t) => ({ _$litStatic$: t, r: u }), _ = (t, ...i) => ({ _$litStatic$: i.reduce((a, s, l) => a + ((e) => {
  if (e._$litStatic$ !== void 0)
    return e._$litStatic$;
  throw Error(`Value passed to 'literal' function must be a 'literal' result: ${e}. Use 'unsafeStatic' to pass non-literal values, but
            take care to ensure page security.`);
})(s) + t[l + 1], t[0]), r: u }), p = /* @__PURE__ */ new Map(), S = (t) => (i, ...a) => {
  const s = a.length;
  let l, e;
  const o = [], c = [];
  let n, r = 0, $ = !1;
  for (; r < s; ) {
    for (n = i[r]; r < s && (e = a[r], (l = d(e)) !== void 0); )
      n += l + i[++r], $ = !0;
    r !== s && c.push(e), o.push(n), r++;
  }
  if (r === s && o.push(i[s]), $) {
    const f = o.join("$$lit$$");
    (i = p.get(f)) === void 0 && (o.raw = o, p.set(f, i = o)), a = c;
  }
  return t(i, ...a);
}, w = S(v), b = S(h);
export {
  w as html,
  _ as literal,
  b as svg,
  m as unsafeStatic,
  S as withStatic
};
